// The Terms of Service are shown only in the sign-up popup (TermsModal);
// the Privacy Policy is on the website.
export const PRIVACY_POLICY_URL = "https://www.getphantm.ai/privacy/";
// Phantm's booking page: a custom Benchmark for teams running AI at scale.
export const BOOK_A_CALL_URL = "https://calendly.com/d/cvty-7vs-3pj/meet-with-phantm";
